import { Empty, notification, Spin } from "antd";
import esES from 'antd/lib/locale/es_ES';
import { CommonSearchForm, InternalPageLayout, Table } from "components";
import { useEffect, useState } from "react";
import { walletColumns } from "utils/tableColumns";
import { useAppDispatch, useAppSelector, usePermissions } from "hooks";
import { setWallets } from "store/hunters/hunters_t";
import { cleanCurrentWallet } from "store/hunters";
import AddWalletsModal from "./AddWalletsModal";
import { postWallet, putWallet } from "api/private";

const Wallets = () => {
    // redux constants
    const dispatch = useAppDispatch();
    const { can } = usePermissions();
    const canWrite = can("wallets", "write");
    const { wallets } = useAppSelector(({ hunters }) => hunters);
    const { data, status } = wallets;
    // state components
    const [search, setSearch] = useState("");
    const [modalShowed, setModalShowed] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [currentWallet, setCurrentWallet] = useState<any>({});

    const registerWallet = async (body:any) => {
        try {
            setIsLoading(true);



            const { success, errors } = Object.keys(currentWallet).length > 0 ?

            await putWallet(body)
            :
            await postWallet(body);
            if (success === "true") {
                dispatch(setWallets());
                dispatch(cleanCurrentWallet());
                onCloseModal();
                notification.success({
                    message: `${Object.keys(currentWallet).length > 0 ? "Actualización" : "Registro"} de Wallet`,
                    description: "Operación Exitosa"
                });
            } else {
                notification.error({
                    message: `${Object.keys(currentWallet).length > 0 ? "Actualización" : "Registro"} de Wallet`,
                    description: `${errors || "Error en la operación"}`
                });
            }
            setIsLoading(false);
        } catch (error:any) {
            notification.error({
                message: `${Object.keys(currentWallet).length > 0 ? "Actualización" : "Registro"} de Wallet`,
                description: `${error.message}`
            });
        }
    }

    const onCloseModal = () => {
        setModalShowed(false);
        setIsLoading(false);
        // dispatch(cleanCurrentWallet());
    }

    const filterWallets = () => {
        if (data) {
            return data.filter((item:any) => item.code.toLowerCase().includes(search.toLowerCase()));
        }
    }

    useEffect(() => {
        dispatch(setWallets());
    }, [])


    return (
  <InternalPageLayout title="Wallets">
            <Spin spinning={status.fetching}>
                <CommonSearchForm
                    clickAdd={() => {
                        setCurrentWallet({});
                        setModalShowed(true)
                    }}
                    search={search}
                    onSearch={({target}: any) => setSearch(target.value.trimStart())}
                    canAdd={canWrite}
                />
                <Table
                    localeProv={esES}
                    size="small"
                    rowKey={'id'}
                    columns={walletColumns(dispatch, () => setModalShowed(true), setCurrentWallet, canWrite)}
                    dataSource={search ? filterWallets()?.sort((a:any, b:any) => a.code.localeCompare(b.code)) : data.length > 0 ? [...data].sort((a:any, b:any) => a.code.localeCompare(b.code)) : []}
                    locale={{
                        triggerDesc: 'Ordenar de forma descendente',
                        triggerAsc: 'Ordenar de forma ascendente',
                        cancelSort: 'Cancelar ordenamiento',
                        emptyText: (
                        <Empty
                            image={Empty.PRESENTED_IMAGE_SIMPLE}
                            description="No hay datos"
                        />
                        )
                    }}
                    scroll={{ x: 'auto' }}
                    pagination={{ defaultPageSize: 10 }}
                />
            </Spin>
            {modalShowed &&
            <AddWalletsModal
                currentWallet={currentWallet}
                okHandler={registerWallet}
                visible={modalShowed}
                closeModal={onCloseModal}
                loading={isLoading}
            />}
        </InternalPageLayout>
    )
}
export default Wallets;
